export const formatDateField = (dateValue) => {
    let formattedDate = '';
  
    // Handle Firebase timestamp objects
    if (dateValue?.seconds) {
      const date = new Date(dateValue.seconds * 1000);
      formattedDate = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    } 
    // Handle Date objects
    else if (dateValue instanceof Date) {
      formattedDate = dateValue.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    }
    // Handle string dates (MM/DD/YYYY format)
    else if (typeof dateValue === 'string') {
      // Check if it's already in a formatted string
      if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateValue)) {
        formattedDate = dateValue;
      } else {
        // Try to parse the string to a date
        try {
          const date = new Date(dateValue);
          if (!isNaN(date.getTime())) {
            formattedDate = date.toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            });
          }
        } catch (e) {
          // If parsing fails, just use the string as is
          formattedDate = dateValue;
        }
      }
    }
  
    return formattedDate;
  };
  
  // Create a React component for date templates
  export const DateTemplate = (props, fieldName = 'date_entered') => {
    const dateValue = props[fieldName];
    const formattedDate = formatDateField(dateValue);
    
    return <span>{formattedDate}</span>;
  };